
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigationItem {
  name: string;
  href: string;
  disabled?: boolean;
}

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  // Verifica se estamos na área logada (dashboard)
  const isLoggedArea = location.pathname.startsWith('/dashboard') || 
                      location.pathname.startsWith('/cadastro-clientes') || 
                      location.pathname.startsWith('/processo');
  
  const publicNavigation: NavigationItem[] = [
    { name: 'Início', href: '/' },
    { name: 'Login', href: '/login' },
  ];

  const privateNavigation: NavigationItem[] = [
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Novo Processo', href: '/processo', disabled: true },
    { name: 'Cadastro de Clientes', href: '/cadastro-clientes', disabled: true },
  ];

  const navigation = isLoggedArea ? privateNavigation : publicNavigation;

  return (
    <header className="border-b border-border-subtle bg-card shadow-sm">
      <div className="max-w-[3000px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to={isLoggedArea ? "/dashboard" : "/"} className="flex items-center">
            <img 
              src="/img/habita4u_light.svg" 
              alt="Habita4u" 
              className="h-8 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              item.disabled ? (
                <span
                  key={item.name}
                  aria-disabled="true"
                  className="px-3 py-2 text-sm font-instrument font-medium rounded-md whitespace-nowrap text-textSecondary/70 cursor-not-allowed"
                >
                  {item.name}
                </span>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`px-3 py-2 text-sm font-instrument font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === item.href
                      ? 'text-primary bg-primary/10'
                      : 'text-textPrimary hover:text-primary hover:bg-primary/5'
                  }`}
                >
                  {item.name}
                </Link>
              )
            ))}
            {isLoggedArea && (
              <Link
                to="/"
                className="px-3 py-2 text-sm font-instrument font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer text-red-600 hover:text-red-700 hover:bg-red-500/10 dark:text-red-300"
              >
                <i className="ri-logout-box-line mr-1"></i>
                Sair
              </Link>
            )}
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-textPrimary hover:text-primary hover:bg-primary/10 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <nav className="space-y-1 border-t border-border-subtle bg-card px-2 pb-3 pt-2">
              {navigation.map((item) => (
                item.disabled ? (
                  <span
                    key={item.name}
                    aria-disabled="true"
                    className="block px-3 py-2 text-base font-instrument font-medium rounded-md text-textSecondary/70 cursor-not-allowed"
                  >
                    {item.name}
                  </span>
                ) : (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className={`block px-3 py-2 text-base font-instrument font-medium rounded-md transition-colors cursor-pointer ${
                      location.pathname === item.href
                        ? 'text-primary bg-primary/10'
                        : 'text-textPrimary hover:text-primary hover:bg-primary/5'
                    }`}
                  >
                    {item.name}
                  </Link>
                )
              ))}
              {isLoggedArea && (
                <Link
                  to="/"
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-3 py-2 text-base font-instrument font-medium rounded-md transition-colors cursor-pointer text-red-600 hover:text-red-700 hover:bg-red-500/10 dark:text-red-300"
                >
                  <i className="ri-logout-box-line mr-1"></i>
                  Sair
                </Link>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
